export const SKETCH_PANEL_CLASS_NAME = 'esri-sketch__panel';
export const SKETCH_PANEL_SELECTOR = `.${SKETCH_PANEL_CLASS_NAME}`;
